import { setSessionLimitAction } from 'js/hooks/session/store/actions';

export const actionShowSessionTimerInfo = ({ actionInfo }, { dispatch }) => {
    const { sessionLimit } = actionInfo;

    dispatch(setSessionLimitAction(sessionLimit));
};
